import apiClient from "./config";
import { CALENDAR_ENDPOINTS } from "./endpoints";

export const getEvents = () => apiClient.get(CALENDAR_ENDPOINTS.GET_EVENTS);
export const getCategories = () => apiClient.get(CALENDAR_ENDPOINTS.GET_CATEGORIES);
export const getUpCommingEvent = () => apiClient.get(CALENDAR_ENDPOINTS.GET_UPCOMMINGEVENT);
export const addNewEvent = (event) => apiClient.create(CALENDAR_ENDPOINTS.ADD_NEW_EVENT, event);
export const updateEvent = (event) => apiClient.put(CALENDAR_ENDPOINTS.UPDATE_EVENT, event);
export const deleteEvent = (event) => apiClient.delete(CALENDAR_ENDPOINTS.DELETE_EVENT, { headers: { event } });

